import React from 'react';
import { motion } from 'framer-motion';
import { IconStar, IconDiamond, IconCertificate } from './ui/Icons';
export function About() {
  return <section id="sobre-mi" className="py-24 bg-brand-cream overflow-hidden" data-id="element-13">
      <div className="container mx-auto px-6 md:px-12" data-id="element-14">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-15">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-16">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:mx-0 shadow-soft-lg" data-id="element-17">
              <video src="https://cdn.magicpatterns.com/uploads/rNAJBHXPUMkkvxZUbNFz6L/SaveClip.App_AQPqWeB8mfxV4HXeTE1a7FxWLHpTbyJ-j5syC_mjCivIXtRmaLaUje6wLHMvKxwhRzfuESM7jIxb6UMk1h79CVXIyinYViXm3HvIS80.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-18" />
              <div className="absolute inset-0 border border-white/20 rounded-2xl m-4 pointer-events-none" data-id="element-19" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-rose/20 rounded-full blur-2xl -z-10" data-id="element-20" />
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-brand-gold/20 rounded-full blur-2xl -z-10" data-id="element-21" />
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-22">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-mocha mb-6" data-id="element-23">
              7 Años Transformando tu Belleza
            </h2>
            <div className="h-[1px] bg-brand-gold w-16 mb-8" data-id="element-24" />

            <div className="space-y-4 text-brand-mocha/80 mb-10 leading-relaxed" data-id="element-25">
              <p data-id="element-26">
                Soy Candelaria Fernandez, fundadora de CF Studio. Mi pasión por
                la estética y el cuidado personal me llevó a crear este espacio
                pensado exclusivamente para vos.
              </p>
              <p data-id="element-27">
                Creemos que cada detalle importa. Por eso, nos enfocamos en
                brindar un servicio personalizado, donde la calidad de los
                productos y la precisión de la técnica se unen para lograr
                resultados impecables y duraderos, siempre cuidando la salud de
                tus uñas y cabello.
              </p>
            </div>

            {/* Trust Badges */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-28">
              <div className="flex flex-col items-center sm:items-start text-center sm:text-left" data-id="element-29">
                <div className="w-10 h-10 rounded-full bg-brand-rose/10 flex items-center justify-center text-brand-rose mb-3" data-id="element-30">
                  <IconStar className="w-5 h-5" data-id="element-31" />
                </div>
                <h4 className="font-serif text-brand-mocha font-medium mb-1" data-id="element-32">
                  7 años
                </h4>
                <p className="text-xs text-brand-mocha/60" data-id="element-33">de experiencia</p>
              </div>

              <div className="flex flex-col items-center sm:items-start text-center sm:text-left" data-id="element-34">
                <div className="w-10 h-10 rounded-full bg-brand-rose/10 flex items-center justify-center text-brand-rose mb-3" data-id="element-35">
                  <IconDiamond className="w-5 h-5" data-id="element-36" />
                </div>
                <h4 className="font-serif text-brand-mocha font-medium mb-1" data-id="element-37">
                  Productos
                </h4>
                <p className="text-xs text-brand-mocha/60" data-id="element-38">premium</p>
              </div>

              <div className="flex flex-col items-center sm:items-start text-center sm:text-left" data-id="element-39">
                <div className="w-10 h-10 rounded-full bg-brand-rose/10 flex items-center justify-center text-brand-rose mb-3" data-id="element-40">
                  <IconCertificate className="w-5 h-5" data-id="element-41" />
                </div>
                <h4 className="font-serif text-brand-mocha font-medium mb-1" data-id="element-42">
                  Técnicas
                </h4>
                <p className="text-xs text-brand-mocha/60" data-id="element-43">certificadas</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}